import React from "react";
import { useFeatureAccess } from "../hooks/useFeatureAccess";
import { Link } from "react-router-dom";
import "../styles/upgrade-prompt.css";

interface UpgradePromptProps {
  featureId: string;
  /** Optional custom title (defaults to "Feature Locked") */
  title?: string;
  /** Optional custom description */
  description?: string;
  /** Optional custom button text */
  buttonText?: string;
}

/**
 * Component that prompts user to upgrade to access a feature
 * Shows which plan is needed and links to pricing page
 */
export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  featureId,
  title = "Feature Locked",
  description,
  buttonText = "View Plans",
}) => {
  const { inaccessibleFeatures, userPlan } = useFeatureAccess();

  // Find the feature to show its name
  const feature = inaccessibleFeatures.find((f) => f.id === featureId);

  return (
    <div className="upgrade-prompt" id={`upgrade-prompt-${featureId}`}>
      <h3 className="upgrade-prompt-title">{title}</h3>

      {description ? (
        <p className="upgrade-prompt-description">{description}</p>
      ) : (
        <>
          {feature && (
            <p className="upgrade-prompt-description">
              <span className="upgrade-prompt-feature-name">
                {feature.name}
              </span>{" "}
              is not available with your current plan.
            </p>
          )}
          {userPlan && (
            <p className="upgrade-prompt-plan-info">
              You&apos;re on the{" "}
              <span className="upgrade-prompt-plan-name">{userPlan.name}</span>{" "}
              plan
            </p>
          )}
        </>
      )}

      <Link to="/pricing" className="upgrade-prompt-cta">
        {buttonText}
      </Link>
    </div>
  );
};
